export default __webpack_public_path__ + "static/media/Ismail-Malik.4c948053.jpg";